// services/device.ts
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQueryWithReauth";
import { Device, PaginatedDeviceResponse, GetAllDeviceParams } from "../types/device";
import { OnlineSession } from "../types/onlineSession";

export const deviceApi = createApi({
  reducerPath: "deviceApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["device"],
  endpoints: (builder) => ({

    // ── Đã cập nhật: nhận params phân trang, trả về PaginatedDeviceResponse ──
    getAllDevice: builder.query<PaginatedDeviceResponse, GetAllDeviceParams>({
      query: ({ page = 1, limit = 10, status } = {}) => ({
        url: "device/get-all-device",
        method: "GET",
        params: {
          page,
          limit,
          // Chỉ gửi status nếu có giá trị
          ...(status != null && { status }),
        },
      }),
      // Merge data khi load more (infinite scroll) nếu cần
      // serializeQueryArgs: ({ endpointName }) => endpointName,
      // merge: (currentCache, newData) => {
      //   currentCache.data.push(...newData.data);
      //   currentCache.pagination = newData.pagination;
      // },
      // forceRefetch: ({ currentArg, previousArg }) =>
      //   currentArg?.page !== previousArg?.page,
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({ type: "device" as const, _id })),
              { type: "device", _id: "LIST" },
            ]
          : [{ type: "device", _id: "LIST" }],
    }),

    // ── Không thay đổi ──────────────────────────────────────────────────────
    getDevicesByUserId: builder.query<Device[], string>({
      query: (id) => `device/get-list-device-by-userid/${id}`,
      providesTags: (result?: Device[]) =>
        result
          ? [
              ...result.map(({ _id }) => ({ type: "device" as const, _id })),
              { type: "device", _id: "LIST" },
            ]
          : [{ type: "device", _id: "LIST" }],
    }),

    getOnlineSessions: builder.query<OnlineSession[], string | null>({
      query: (id) => ({
        url: `device/get-online-sessions/${id}`,
        method: "GET",
      }),
    }),

    createOrUpdateDevice: builder.mutation<Device, Partial<Device>>({
      query: (device) => ({
        url: "device/create-or-update",
        method: "POST",
        body: device,
      }),
      invalidatesTags: ["device"],
    }),

    addUserPermision: builder.mutation({
      query: (data) => ({
        url: "device/add-user-permission-device",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["device"],
    }),

    changeStatusDevice: builder.mutation({
      query: (data) => ({
        url: "device/change-status",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["device"],
    }),

    getAllDeviceIsNotUserPermission: builder.query({
      query: (id) => ({
        url: `device/get-devices-not-user-permision/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, _id) => [{ type: "device", _id }],
    }),
  }),
});

export const {
  useGetAllDeviceQuery,
  useGetDevicesByUserIdQuery,
  useCreateOrUpdateDeviceMutation,
  useAddUserPermisionMutation,
  useChangeStatusDeviceMutation,
  useGetAllDeviceIsNotUserPermissionQuery,
  useGetOnlineSessionsQuery,
} = deviceApi;